import Vue from "vue"; // Ensure you import Vue here to access global properties like `$toast`
import Vuex from "vuex";
import { fields, templates, users, notifications,estimate as estimates, globalFields, serviceFields, fieldOrders, zipcodes, carMake, fieldConditions } from "../assets/js/firebase";
import { customerResponse, status } from "../assets/js/default.js";
import { formatDate } from "../assets/js/common";

Vue.use(Vuex);

let unsubscribe = null;
let unsubscribeTemplates = null;
let unsubscribeUser = null;
let unsubscribeNotification = null;
let unsubscribeEstimate = null;

export default new Vuex.Store({
  state: {
    _estimate : [],
    _estimatesQuery: {},
    _fields: [],
    _technicianGroups: [],
    _templates: [],
    _customers: [],
    _customersQuery: {},
    _jobQuery: {},
    _jobs: [],
    _users: [],
    _makes: [],
    _makesUnlocking: [],
    _notifications: [],
    _sms: [],
    _globalFields: [],
    _serviceFields: [],
    _calculatedFields: [],
    _fieldOrders: [],
    _technicians: [],
    _zipcodes: [],
    _dispositions: [],
    _user: {},
    _smsTemplates: [],
    _cmp: [],
    _removedFields: [],
    _fieldConditions: [],
    _visibleFields: [],
    _makesLoading: false,
    shouldRerenderLeftComponent: false,
    reRenderOutsideTechnician: false,
  },
  getters: {
    fieldConditions(state) {
      return state._fieldConditions;
    },
    smsTemplates(state) {
      return state._smsTemplates;
    },
    technicianGroups(state) {
      return state._technicianGroups;
    },
    fieldOrders(state) {
      return state._fieldOrders;
    },
    globalFields(state) {
      return state._globalFields;
    },
    serviceFields(state) {
      return state._serviceFields;
    },
    calculatedFields(state) {
      return state._calculatedFields;
    },
    fields(state) {
      return state._fields;
    },
    templates(state) {
      return state._templates;
    },
    customers(state) {
      return state._customers;
    },
    customersQuery(state) {
      return state._customersQuery;
    },
    jobs(state) {
      return state._jobs;
    },
    makes(state) {
      return state._makes;
    },
    makesUnlocking(state) {
      return state._makesUnlocking;
    },
    jobQuery(state) {
      return state._jobQuery;
    },
    users(state) {
      return state._users;
    },
    sms(state) {
      return state._sms;
    },
    notifications(state) {
      return state._notifications;
    },
    zipcodes(state) {
      return state._zipcodes;
    },
    cmp(state) {
      return state._cmp;
    },
    technicians(state) {
      return state._technicians.map((item) => {
        let name = item.first_name + " " + item.last_name;
        item.name = name;
        return item;
      });
    },
    dispositions(state) {
      return state._dispositions;
    },
    user(state) {
      return state._user;
    },
    removedFields(state) {
      return state._removedFields;
    },
    estimate(state) {
      return state._estimate;
    },
    estimatesQuery(state) {
      return state._estimatesQuery;
    },
    visibleFields(state) {
      return state._visibleFields;
    },
    makesLoading(state) {
      return state._makesLoading;
    }
  },
  mutations: {
    SET_FIELD_CONDITIONS(state, val) {
      state._fieldConditions = val;
    },
    SET_SMS_TEMPLATES(state, val) {
      state._smsTemplates = val;
    },
    SET_TECHNICIAN_GROUP(state, val) {
      state._technicianGroups = val;
    },
    SET_REMOVED_FIELDS(state, value) {
      state._removedFields = value;
    },
    SET_GLOBLE_FIELDS(state, value) {
      state._globalFields = value.filter((i) => i.removed !== true);
    },
    SET_SERVICE_FIELDS(state, value) {
      state._serviceFields = value.filter((i) => i.removed !== true);
    },
    SET_CALCULATED_FIELDS(state, value) {
      state._calculatedFields = value;
    },
    SET_FIELD_ORDERS(state, value) {
      state._fieldOrders = value;
    },
    SET_FIELDS(state, value) {
      state._fields = value;
    },
    SET_TEMPLATES(state, value) {
      state._templates = value;
    },
    SET_NOTIFICATIONS(state, value) {
      state._notifications = value;
    },
    SET_CUSTOMERS(state, value) {
      state._customers = value;
    },
    SET_USERS(state, value) {
      state._users = value;
    },
    SET_ZIPCODES(state, value) {
      state._zipcodes = value;
    },
    SET_CMP(state, value) {
      state._cmp = value;
    },
    REMOVE_CUSTOMER(state, id) {
      let list = [];
      state._customers.forEach((item) => {
        if (item.id !== id) {
          list.push(item);
        }
      });
      state._customers = list;
    },
    UPDATE_CUSTOMER(state, data) {
      let doc = {};
      let list = [];
      Object.keys(data).forEach((key) => {
        doc[key] = data[key];
      });
      doc.created_at = formatDate(doc.created_at);
      doc.updated_at = formatDate(doc.updated_at);
      customerResponse.forEach((item) => {
        if (item.value === doc.status) {
          doc.status = item.name;
        }
      });

      state._customers.forEach((item) => {
        if (item.id === doc.id) {
          list.push(doc);
        } else {
          list.push(item);
        }
      });
      state._customers = list;
    },
    SET_CUSTOMERS_QUERY(state, value) {
      state._customersQuery = value;
    },
    SET_JOBS(state, value) {
      state._jobs = value;
    },
    SET_MAKES(state, value) {
      state._makes = value;
    },
    SET_MAKES_UNLOCKING(state, value) {
      state._makesUnlocking = value;
    },
    REMOVE_JOBS(state, id) {
      let list = [];
      state._jobs.forEach((item) => {
        if (item.id !== id) {
          list.push(item);
        }
      });
      state._jobs = list;
    },
    UPDATE_JOBS(state, data) {
      let doc = {};
      let list = [];
      Object.keys(data).forEach((key) => {
        doc[key] = data[key];
      });
      doc.created_at = formatDate(doc.created_at);
      doc.updated_at = formatDate(doc.updated_at);
      status.forEach((item) => {
        if (item.value === doc.status) {
          doc.status = item.name;
        }
      });
      state._jobs.forEach((item) => {
        if (item.id === doc.id) {
          list.push(doc);
        } else {
          list.push(item);
        }
      });
      state._jobs = list;
    },
    SET_JOB_QUERY(state, value) {
      state._jobQuery = value;
    },
    SET_SMS(state, val) {
      state._sms = val;
    },
    SET_TECHNICIANS(state, val) {
      state._technicians = val;
    },
    SET_DISPOSITIONS(state, val) {
      state._dispositions = val;
    },
    SET_USER(state, val) {
      state._user = val;
    },
    TRIGGER_RERENDER(state, val) {
      state.shouldRerenderLeftComponent = val;
    },
    RERENDER_OUTSIDE_TECHNICIAN(state, val) {
      state.reRenderOnOutsideTechnician = val;
    },
    SET_ESTIMATES(state, value) {
      state._estimate = value;
    },
    SET_ESTIMATES_QUERY(state, value) {
      state._estimatesQuery = value;
    },
    SET_VISIBLE_FIELDS(state, value) {
      state._visibleFields = value;
    },
    SET_MAKES_LOADING(state, value) {
      state._makesLoading = value;
    }
  },
  actions: {
    async listen(context, { store, query }) {
      query.onSnapshot((snap) => {
        let docs = [];
        snap.docs.forEach((item) => {
          let doc = item.data();
          doc.id = item.id;
          let { updated_at } = doc;
          if (updated_at !== "") doc.updated = formatDate(updated_at);

          docs.push(doc);
        });
        context.commit(store, docs);
      });
    },
    async listenDoc(context, { store, query }) {
      query.onSnapshot((snap) => {
        let doc = snap.data();
        doc.id = snap.id;
        context.commit(store, doc);
      });
    },
    async listenNotification(context) {
      console.log("welcome");
      try {
        let list = [];
        let snap = await notifications
          .orderBy("updated_at", "desc")
          .limit(50)
          .get();
        snap.docs.forEach((item) => {
          let doc = item.data();
          doc.id = item.id;
          list.push(doc);
        });
        context.commit("SET_NOTIFICATIONS", list);
      } catch (error) {
        console.log(error);
      }
      let query = notifications.orderBy("updated_at", "desc").limit(1);
      unsubscribeNotification = query.onSnapshot((snap) => {
        let list = [];
        context.getters.notifications.forEach((item) => {
          list.push(item);
        });
        snap.docs.forEach((doc) => {
          let index = -1;
          let data = doc.data();
          data.id = doc.id;
          list.forEach((item, i) => {
            if (item.id === doc.id) index = i;
          });
          if (index === -1) {
            list.unshift(data);
          } else {
            list[index] = data;
          }
        });
        context.commit("SET_NOTIFICATIONS", list);
      });
    },
    unSubscribeField() {
      if (unsubscribe !== null) unsubscribe();
      if (unsubscribeTemplates !== null) unsubscribeTemplates();
      if (unsubscribeUser !== null) unsubscribeUser();
      if (unsubscribeNotification !== null) unsubscribeNotification();
      if (unsubscribeEstimate !== null) unsubscribeEstimate();
    },
    subscribeField(context) {
      context.dispatch("listenNotification");
      unsubscribe = fields.onSnapshot((snap) => {
        let list = [];
        snap.docs.forEach((doc) => {
          let { name } = doc.data();
          list.push(name);
        });
        context.commit("SET_FIELDS", list);
      });
      unsubscribeTemplates = templates
        .orderBy("updated_at", "desc")
        .onSnapshot((snap) => {
          let list = [];
          snap.docs.forEach((doc) => {
            let data = doc.data();
            let { updated_at } = data;
            if (updated_at !== "") data.updated = formatDate(updated_at);
            data.id = doc.id;
            if(!data.isPublic){
              list.push(data);
            }
          });
          context.commit("SET_TEMPLATES", list);
        });
      unsubscribeUser = users
        .orderBy("updated_at", "desc")
        .onSnapshot((snap) => {
          let list = [];
          snap.docs.forEach((doc) => {
            let data = doc.data();
            let { updated_at, first_name, last_name } = data;
            let name = `${first_name} ${last_name}`;
            if (updated_at !== "") data.updated = formatDate(updated_at);
            data.name = name;
            data.id = doc.id;
            list.push(data);
          });
          context.commit("SET_USERS", list);
        });
      unsubscribeEstimate = estimates
        .orderBy("updated_at", "desc")
        .onSnapshot((snap) => {
          let list = [];
          snap.docs.forEach((doc) => {
            let data = doc.data();
            let { updated_at } = data;
            if (updated_at !== "") data.updated = formatDate(updated_at);
            data.id = doc.id;
            list.push(data);
          });
          context.commit("SET_ESTIMATES", list);
        });
    },
    triggerRerender({ commit }, name = null) {
      commit("TRIGGER_RERENDER", name);
    },
    reRenderOutsideTechnician({ commit }, name = null) {
      commit("RERENDER_OUTSIDE_TECHNICIAN", name);
    },

    /**
     * Fetch a single template document by its name.
     *
     * @param {Object} _ - Vuex context (unused)
     * @param {string} name - Name of the template to fetch
     * @returns {Object|null} Template object with `id`, or null if not found
     * @throws Will throw an error if Firestore query fails
     */
    async fetchTemplateByName(_,name) {
      try {
        let query = await templates.where("name", "==", name).limit(1).get();
        if (!query.empty) {
          let doc = query.docs[0];
          let data = doc.data();
          data.id = doc.id;
          return data;
        }
        return null;
      } catch (error) {
        console.error("Error fetching template by name:", error);
        throw error;
      }
    },
    

    /**
     * Fetch and prepare field and related data for quick lookup form.
     *
     * Optionally filters fields based on provided field IDs.
     *
     * @param {Object} context - Vuex context
     * @param {Function} context.commit - Vuex commit function
     * @param {Array<string>} fieldIds - Optional array of field IDs to filter results
     *
     * @returns {void}
     */
    async fetchQuickLookUpFields({ commit }) {
      try {
        const [
          globalSnap,
          serviceSnap,
          ordersSnap,
          zipcodesSnap,
          fieldConditionsSnap,
        ] = await Promise.all([
          globalFields.where("type", "==", "global").orderBy("name", "asc").get(),
          serviceFields.where("type", "==", "service").orderBy("name", "asc").get(),
          fieldOrders.get(),
          zipcodes.orderBy("updated_at", "desc").get(),
          fieldConditions.orderBy("updatedAt", "desc").get(),
        ]);

        let globalData = globalSnap.docs.map(doc => ({ ...doc.data(), id: doc.id }));
        let serviceData = serviceSnap.docs.map(doc => ({ ...doc.data(), id: doc.id }));

        commit("SET_GLOBLE_FIELDS", globalData);
        commit("SET_SERVICE_FIELDS", serviceData);
        commit("SET_FIELD_ORDERS", ordersSnap.docs.map(doc => ({ ...doc.data(), id: doc.id })));
        commit("SET_ZIPCODES", zipcodesSnap.docs.map(doc => ({ ...doc.data(), id: doc.id })));
        commit("SET_FIELD_CONDITIONS", fieldConditionsSnap.docs.map(doc => ({ ...doc.data()})));
        
        commit("SET_MAKES_LOADING", true);

        setTimeout(async ()=>{
          try {
            const snap = await carMake.orderBy("updated_at", "desc").get();
            const makeSnap = snap.docs.map(doc => ({ ...doc.data(), id: doc.id }));
            commit("SET_MAKES",makeSnap);
          }

          catch (error) {
            console.error("Error fetching car makes:", error);
          } finally {
            commit("SET_MAKES_LOADING", false);
          }
        },0)


      } catch (error) {
        console.error("Error fetching public fields:", error);
      }
    },

    async fetchVisibleFields({ commit }, fieldIds = []) {
      try {
        commit("SET_VISIBLE_FIELDS", fieldIds);
      } catch (error) {
        console.error("Error fetching visible fields:", error);
      }
    }
  },
  modules: {},
});
